import i18n from '../../i18n';

/**
 * Date/heure des tickets portés.
 *
 * ⚠️ Différence assumée avec la console : celle-ci force le fuseau du MAGASIN
 * (`STORE_TIMEZONE`) parce qu'elle peut être ouverte depuis n'importe quel poste. La
 * borne, elle, EST dans le restaurant : on utilise donc l'horloge locale de l'appareil,
 * exactement comme les formateurs historiques (`new Date().toLocaleString('fr-FR')`).
 * Introduire un fuseau en dur ferait diverger les tickets d'une même commande.
 */

/** Locale BCP-47 déduite de la langue d'interface. Relue à chaque appel (langue à chaud). */
export const currentLocale = (): string => {
  const map: Record<string, string> = {
    fr: 'fr-FR',
    en: 'en-GB',
    ar: 'ar-TN',
    es: 'es-ES',
    de: 'de-DE',
  };
  let lang = 'fr';
  try {
    lang = i18n.resolvedLanguage || i18n.language || 'fr';
  } catch {
    lang = 'fr';
  }
  return map[lang] || 'fr-FR';
};

export const formatDateTime = (date?: string | Date | null): string => {
  const value = date ?? new Date();
  try {
    const parsed = typeof value === 'string' ? new Date(value) : value;
    if (!parsed || Number.isNaN(parsed.getTime())) return '';
    return parsed.toLocaleString(currentLocale(), {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '';
  }
};
